import { createContext, useContext } from 'react';
import type { buttonUIFactory, popupUIFactory, Widget } from '@yandex-int/messenger.widget';

type MessengerUi = ReturnType<typeof buttonUIFactory> | ReturnType<typeof popupUIFactory>;

interface SupportChatContextValue {
    widget: Widget | null;
    ui: MessengerUi | null;
    guid: string;
    registerMountTarget: (element: HTMLElement | null) => void;
}

export const SupportChatContext = createContext<SupportChatContextValue | null>(null);

export const useSupportChat = () => {
    const context = useContext(SupportChatContext);

    if (!context) {
        throw new Error('useSupportChat must be used within SupportChatProvider');
    }

    return context;
};
